import { format as origFormat } from 'date-fns'
import { cs } from 'date-fns/locale'

export function format (date: Date | number, format: string): string {
  return origFormat(date, format, { locale: cs })
}
